import { render, staticRenderFns } from "./ProductSize.vue?vue&type=template&id=4bf6aec3&"
import script from "./ProductSize.vue?vue&type=script&lang=js&"
export * from "./ProductSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports